import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { URL_API } from "../shared/consts";
import { redirectLogin } from "../utils/functions.util";

/** THUNKS */
export const getUbigeoList = createAsyncThunk(
  "ubigeo/getUbigeoList",
  async (values, { rejectWithValue }) => {
    try {
      const { page, size, search } = values;
      const filter = Object.entries(search);
      if (filter.length) {
        const res = await axios.post(
          `${URL_API}/ubigeos/search`,
          {
            filters: search,
            page: page,
            size: size,
          },
          {
            withCredentials: true,
          }
        );
        return res.data;
      }
      const res = await axios.get(
        `${URL_API}/ubigeos?page=${page}&size=${size}`,
        {
          withCredentials: true,
        }
      );
      return res.data;
    } catch (error) {
      redirectLogin(error?.response?.status);
      const message =
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.message;
      return rejectWithValue(message);
    }
  }
);

export const createUbigeo = createAsyncThunk(
  "ubigeo/createUbigeo",
  async (values, { rejectWithValue }) => {
    try {
      const res = await axios.post(`${URL_API}/ubigeos`, values, {
        withCredentials: true,
      });
      return res.data;
    } catch (error) {
      redirectLogin(error?.response?.status);
      const message =
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.message;
      return rejectWithValue(message);
    }
  }
);

export const updateUbigeo = createAsyncThunk(
  "ubigeo/updateUbigeo",
  async (values, { rejectWithValue }) => {
    try {
      const res = await axios.put(`${URL_API}/ubigeos/${id}`, values, {
        withCredentials: true,
      });
      return res.data;
    } catch (error) {
      redirectLogin(error?.response?.status);
      const message =
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.message;
      return rejectWithValue(message);
    }
  }
);

export const deleteUbigeo = createAsyncThunk(
  "ubigeo/deleteUbigeo",
  async (values, { rejectWithValue }) => {
    try {
      const { id } = values;
      const res = await axios.delete(`${URL_API}/ubigeos/${id}`, {
        withCredentials: true,
      });
      return res.data;
    } catch (error) {
      redirectLogin(error?.response?.status);
      const message =
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.message;
      return rejectWithValue(message);
    }
  }
);
